import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Container, Row, Col } from 'react-grid-system'
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';

import {
  UniConditionalRender,
  IPaginatedResponseC,
  IReaderC,
  IMultiInputUpdate,
  IUniToast_Alert,
  ReaderC,
  OrganizationC,
  UniKeyVal,
  UniLocalize,
  EOrganizationStatus,
  EOperationCodesC,
  ES10nSettings,
  Editable,
  notBlankV10n,
  minV10n,
  maxV10n,
  UniButton,
  withRouteMatchParams,
  IRouteMatchParamsHOCProps,
  EMessageType,
} from '@unikey/unikey-commons/release/comm';

import {
  canI,
  s10n,

  attemptRetrieveOrgDetails,
  attemptUpdateOrgDetails,
  handleOrgDetailsChange,
  attemptRetrieveDealerDetails,
  PartnerCustomizations, IPartnerCustomizations,
  addAlert,
  navConfig, ENavPages,
  addPendingRedirect,
  IPendingRedirectActionParams,
  ReaderListContainer,
  CredentialListContainer
} from '../internal';

interface IProps extends WrappedComponentProps, IPartnerCustomizations, IRouteMatchParamsHOCProps {
  noReadersFlow?: boolean,

  orgId: string,
  orgName: Editable<string>,
  orgStatus: Editable<number>,
  orgReaders: IPaginatedResponseC<IReaderC, ReaderC>,

  permissionToUpdateOrgDetails: boolean,
  
  showAlertNotice(notice: IUniToast_Alert): void,
  getOrgDetails(orgId: string): Promise<void>,
  updateOrgDetails(orgId: string): Promise<void>,
  handleDetailsChange(change: IMultiInputUpdate): void,
  getDealerAccountDetails(): Promise<void>,
  addPendingRedirect(redirOpts: IPendingRedirectActionParams): void,
}

class OrganizationDetailsContainer extends Component<IProps> {
  constructor(props: IProps) {
    super(props);
  }

  componentDidMount() {
    this.props.getOrgDetails(this.props.match.params.organizationId ?? '');
  }

  // org update request
  _orgStatusChange = (status: Editable<number>) => {
    this.props.handleDetailsChange({ status });
  }

  _orgNameChange = (name: Editable<string>) => {
    this.props.handleDetailsChange({ name });
  }

  _saveOrgDetailsAndReload = () => {
    return this.props.updateOrgDetails(this.props.match.params.organizationId ?? '');
  }

  render() {
    if (this.props.render) {
      return this.props.render();
    }


    // permissions
    const permissionToUpdateOrgDetails = canI(EOperationCodesC.UpdateOrg, this.props.activeDealerId, this.props.orgId);

    return (
      <section className="orgDetails-container">
        <Row>
          <Col>
            <h3 className="organization-details-title">{this.props.orgName.value ? this.props.orgName.value : (<UniLocalize translate="organizationDetails" />)}</h3>
          </Col>
        </Row>

        <UniKeyVal
          label={`orgDetails`}
          showLoader={!this.props.orgId}
          preventEdit={!permissionToUpdateOrgDetails}
          cancelClick={this.props.getOrgDetails.bind(this, this.props.match.params.organizationId ?? '')}
          saveClick={this._saveOrgDetailsAndReload}
          fields={[
            {
              keyName: 'identifier',
              value: '' + this.props.orgId,
              type: 'string',
              disabled: true,
            },
            {
              keyName: 'name',
              value: `${this.props.orgName.value}`,
              type: 'string',
              preventTranslate: true,
              placeholderKey: 'organizationName',
              handleUpdate: this._orgNameChange,
              validations: [notBlankV10n]
            },
            {
              keyName: 'status',
              value: `${this.props.orgStatus.value}`,
              type: 'tagdot',
              enumType: EOrganizationStatus,
              handleUpdate: this._orgStatusChange
            }
          ]} />

        {/* Show the Reader and Credentials Mini Tables */}
        <UniConditionalRender visible={this.props.orgId === this.props.match.params.organizationId}>
          <Row>
            <UniConditionalRender visible={!this.props.noReadersFlow}>
              <Col xs={24} md={12}>
                <ReaderListContainer orgId={this.props.match.params.organizationId} isMini={true} />
              </Col> 
            </UniConditionalRender>

            <Col xs={24} md={12}>
              <CredentialListContainer orgId={this.props.match.params.organizationId} isMini={true} />
            </Col>

          </Row>
        </UniConditionalRender>

      </section>
    )
  }
}

function mapStateToProps(state: any, props: IProps) {

  return {
    orgId: state.orgDetails.orgData.id,
    orgName: state.orgDetails.orgData.name,
    orgStatus: state.orgDetails.orgData.status,
    orgLoading: state.orgDetails.loading,
    orgReaders: state.orgDetails.orgReaders,
    
  }
}

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
  getOrgDetails: attemptRetrieveOrgDetails,
  updateOrgDetails: attemptUpdateOrgDetails,
  handleDetailsChange: handleOrgDetailsChange,
  getDealerAccountDetails: attemptRetrieveDealerDetails,
  showAlertNotice: addAlert,
  addPendingRedirect
}, dispatch)

export default PartnerCustomizations(
  connect(mapStateToProps, mapDispatchToProps)(
    withRouteMatchParams(injectIntl(OrganizationDetailsContainer))
  ), { componentName: 'OrganizationDetails' })
